var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcHeartLevel3 = function SvgIcHeartLevel3(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m9.043 1.81-1.03 1.03-1.029-1.03C5.44.267 2.917.263 1.377 1.803s-1.535 4.062.01 5.607l1.029 1.03 5.598 5.598 5.598-5.598 1.03-1.03c1.544-1.545 1.547-4.068.008-5.607A3.94 3.94 0 0 0 11.855.65a3.966 3.966 0 0 0-2.812 1.16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F1C036",
    d: "M11.704 2.296a1.021 1.021 0 0 0-1.44.002L10 2.562l-.264-.264a1.021 1.021 0 0 0-1.44-.002 1.021 1.021 0 0 0 .002 1.44L8.562 4 10 5.438 11.437 4l.265-.264a1.021 1.021 0 0 0 .002-1.44"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F1C036",
    d: "M14.65 1.802c-1.54-1.54-4.063-1.536-5.607.01L8.013 2.84 6.985 1.811C5.44.266 2.916.262 1.377 1.801c-1.54 1.54-1.535 4.063.01 5.608l1.029 1.03 5.598 5.598 5.598-5.599 1.03-1.029c1.544-1.545 1.548-4.068.008-5.607",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M13.63 1.088c-1.454-1.454-3.838-1.45-5.298.01l-.972.972-.973-.973c-1.46-1.46-3.844-1.463-5.299-.009-1.454 1.455-1.45 3.84.01 5.299l.972.973 5.29 5.29 5.29-5.29.972-.973c1.46-1.46 1.463-3.844.009-5.299",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M2.064 3.91a.37.37 0 1 1-.71.202c-.25-.886.301-1.807 1.22-2.067a.37.37 0 1 1 .202.71c-.537.152-.848.672-.712 1.156z",
    mask: "url(#b)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcHeartLevel3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-heart-level-3.24bb0c353ccefbd4a7c83dc02d347b35.svg";